import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { ReadOnlyField, MSpinner, MSelect } from "components/Shared";
import { ASSIGNMENT_MODE_APPRAISAL, ASSIGNMENT_MODE_INSURANCE } from "components/Assignment";
import MGrid, {
	COL_CODE_CONTROL_NUMBER,
	COL_CODE_SURVEY_TYPE,
	COL_CODE_CUSTOMER_NAME,
	COL_CODE_INSURED_NAME,
	COL_CODE_MAC,
	COL_CODE_CITY,
	COL_CODE_STATE,
	COL_CODE_ZIP,
	COL_CODE_COUNTY,
	FORMATTER_CENTER_ALIGN
} from "components/Shared/MGrid.tsx";
import { DATA_TYPE_NUMBER, DATA_TYPE_DAYS_ELAPSED, DATA_TYPE_STRING, DATA_TYPE_DATE_TIME } from "typeConstants/dataTypes";
import { moneyFormatter } from "components/Shared/Formatters";
import { updateFRServiceBoundary } from "actions/homeowner/fieldReps";
import { DialogContext } from "components/Shared/DialogProvider.tsx";

export const DISPLAY_MODE_CASE_DETAILS = "DISPLAY_MODE_CASE_DETAILS";
export const DISPLAY_MODE_INSPECTOR_CASES = "DISPLAY_MODE_INSPECTOR_CASES";

const SORT_TYPE_NUMBER = "SORT_TYPE_NUMBER";
const SORT_TYPE_DATE = "SORT_TYPE_DATE";
const SORT_TYPE_STRING = "SORT_TYPE_STRING";

class SelectionDetails extends Component {
	static contextType = DialogContext;
	constructor(props) {
		super(props);

		this.state = {
			selectedCaseDetails: [],
			assignedCaseDetails: [],
			selectedInspector: null,
			selectedIndexes: [],
			sortColumn: null,
      boundaryMode: "",
			showCountyDialog: false,
		};
		this.selectedCountyIds = ["placeholder"];

		this.getGridDataSource = this.getGridDataSource.bind(this);
		this.getInspectorDropdownItems = this.getInspectorDropdownItems.bind(this);
		this.fieldRepSelected = this.fieldRepSelected.bind(this);
		this.removeRow = this.removeRow.bind(this);
		this.inspectorDetailsLoaded = this.inspectorDetailsLoaded.bind(this);
		this.hasSelectedInspectorAndCases = this.hasSelectedInspectorAndCases.bind(this);
		this.assignClicked = this.assignClicked.bind(this);
		this.unassignClicked = this.unassignClicked.bind(this);
		this.onRowsSelected = this.onRowsSelected.bind(this);
		this.onRowsDeselected = this.onRowsDeselected.bind(this);
		this.onInspectorDetailsClicked = this.onInspectorDetailsClicked.bind(this);
		this.removeSelectedCases = this.removeSelectedCases.bind(this);
		this.getDetailsControls = this.getDetailsControls.bind(this);
		this.routingClicked = this.routingClicked.bind(this);
		this.renderGrid = this.renderGrid.bind(this);
		this.comparer = this.comparer.bind(this);
		this.gridRowClicked = this.gridRowClicked.bind(this);
		this.sortData = this.sortData.bind(this);
		this.getColumns = this.getColumns.bind(this);
		this.getAssigneeLabel = this.getAssigneeLabel.bind(this);
		this.beginFRGeoCoverage = this.beginFRGeoCoverage.bind(this);
		this.endFRGeoCoverage = this.endFRGeoCoverage.bind(this);
		this.countySelectionChanged = this.countySelectionChanged.bind(this);
		this.startCountySelection = this.startCountySelection.bind(this);
		this.formatCountyBoundaries = this.formatCountyBoundaries.bind(this);
    this.mounted = { current: true };

	}

	componentDidMount() {
		if (this.props.selectedInspectors.length === 1) {
			this.fieldRepSelected(this.props.selectedInspectors[0].inspectorNumber, true);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isFRGeoCoverageMode && this.props.isFRGeoCoverageMode) {
			this.props.saveFRServiceBoundary(null);
			this.props.hideExtraDetails();
		}
		if (this.props.isFRGeoCoverageMode && prevProps.tempFRGeoServiceRegion !== this.props.tempFRGeoServiceRegion) {
			this.context.showYesNo(null, "Do you want to save your changes?", () => this.endFRGeoCoverage(), () => {
				if (this.state.boundaryMode === "draw") this.props.tempFRGeoServiceRegion.clearMapCallback();
				this.props.saveFRServiceBoundary(null);
				this.setState({ boundaryMode: "", showCountyDialog: false });
				this.props.frGeoCoverageMode(false);
		}); 
		}
	}

	componentWillUnmount() {
    this.mounted.current = false;
  }

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.displayMode !== nextProps.displayMode) {
			this.setState({ selectedIndexes: [], lastIndexSelected: null });
		}

		/* Fetching changing check should work for most things
			 but it will not work when removing cases from the list by selecting and removing
			 that is why we also check for changing of lengths on selectedCaseDetails
			 also doing this for assignedCaseDetails just for good measure */
		if ((this.props.isFetchingAssignedCaseDetails && !nextProps.isFetchingAssignedCaseDetails) ||
			(this.props.isFetchingCaseDetails && !nextProps.isFetchingCaseDetails) ||
			(this.props.selectedCaseDetails || []).length !== (nextProps.selectedCaseDetails || []).length ||
			(this.props.assignedCaseDetails || []).length !== (nextProps.assignedCaseDetails || []).length) {
			this.sortData(nextProps.selectedCaseDetails, nextProps.assignedCaseDetails);
		}

		if (this.props.isFetchingCaseDetails && !nextProps.isFetchingCaseDetails && nextProps.selectedCaseDetails?.length === 1) {
			this.props.onCaseSelected(nextProps.selectedCaseDetails[0]);
		}
	}

	comparer(a, b) {
		let aValue = this.mapObjectToRow(a)[this.state.sortColumn];
		let bValue = this.mapObjectToRow(b)[this.state.sortColumn];
		let sortType = this.getColumns().find(c => c.key === this.state.sortColumn).sortType;

		if (sortType === SORT_TYPE_STRING) {
			aValue = "" + aValue;
			bValue = "" + bValue;
		} else if (sortType === SORT_TYPE_DATE) {
			aValue = new Date(aValue);
			bValue = new Date(bValue);
		} else if (sortType === SORT_TYPE_NUMBER) {
			// Cant sort with NaN because it returns false always and messes up the order
			aValue = aValue && parseFloat(aValue);
			bValue = bValue && parseFloat(bValue);
		}

		if (this.state.sortDirection === "ASC") {
			return (aValue > bValue) ? 1 : -1;
		} else if (this.state.sortDirection === "DESC") {
			return (aValue < bValue) ? 1 : -1;
		}
	}

	sortData(caseDetails, assignedDetails) {
		if (!caseDetails) caseDetails = this.props.selectedCaseDetails;
		if (!assignedDetails) assignedDetails = this.props.assignedCaseDetails;

		if (this.state.sortDirection && this.state.sortDirection !== "NONE") {
			if (caseDetails) caseDetails = caseDetails.slice(0).sort(this.comparer);
			if (assignedDetails) assignedDetails = assignedDetails.slice(0).sort(this.comparer);
		}

		this.setState({ selectedCaseDetails: caseDetails, assignedCaseDetails: assignedDetails, selectedIndexes: [], lastIndexSelected: null });
	}

	getAssigneeLabel(showEmployeeType) {
		return this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL
			? "Appraiser"
			: `Field Rep${showEmployeeType ? this.getEmployeeTypeLabel() : ""}`;
	}

	getEmployeeTypeLabel() {
		if (this.props.inspectorDetails?.employmentType) {
			return this.props.inspectorDetails.employmentType === "Full Time" ? " - FT" : " - PT";
		} else return "";
	}

	getGridConfigId() {
		return (this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL ? "Appraisal" : "Insurance") +
			(this.props.displayMode === DISPLAY_MODE_INSPECTOR_CASES ? "AssigneeCases" : "SelectionDetails");
	}

	getColumns() {
		return [
			{ code: COL_CODE_CONTROL_NUMBER, width: 85, dataSource: "caseLocation.caseId" },
			{ code: COL_CODE_SURVEY_TYPE, dataSource: "inspectionType" },
			...(this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL ? [{ key: "daysInStatus", name: "Days In Status", width: 120, dataType: DATA_TYPE_NUMBER, dataSource: "daysInStatus" }] : []),
			...(this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL ? [{ key: "insuranceStatus", name: "Field Status", width: 190, dataSource: "insuranceStatus" }] : []),
			...(this.props.displayMode === DISPLAY_MODE_INSPECTOR_CASES ? [{ key: "dateAssigned", name: "Assigned", width: 175, dataType: DATA_TYPE_DAYS_ELAPSED, dataSource: "dateAssigned" }] : []),
			{ key: "dueDate", name: "Cust Due", width: 175, dataType: DATA_TYPE_DAYS_ELAPSED, dataSource: "caseLocation.customerDueDate" },
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE && this.props.displayMode === DISPLAY_MODE_INSPECTOR_CASES ? [{ key: "frDueDate", name: "FR Due", width: 175, dataType: DATA_TYPE_DAYS_ELAPSED, dataSource: "dateFieldRepDue" }] : []),
			{ key: "daysOld", name: "Days Old", width: 77, dataType: DATA_TYPE_NUMBER, formatter: FORMATTER_CENTER_ALIGN, dataSource: "caseLocation.age" },
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ key: "appointmentDate", name: "Appt Date/Time", width: 175, dataType: DATA_TYPE_DATE_TIME, dataSource: "caseLocation.appointmentDate"}]: []),
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ key: "autoAssignmentEta", name: "Auto-Assignment ETA", width: 175, dataType: DATA_TYPE_DATE_TIME, dataSource: "caseLocation.autoAssignmentEta"}]: []),
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ key: "inspectionEta", name: "Inspection ETA", width: 175, dataType: DATA_TYPE_DATE_TIME, dataSource: "caseLocation.inspectionEta"}]: []),
			{ code: COL_CODE_CUSTOMER_NAME, dataSource: "customer.displayLabel" },
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ key: "appraisalStatus", name: "Appraisal Status", width: 175, dataType: DATA_TYPE_STRING, dataSource: "appraisalStatus" }] : []),
			{ code: COL_CODE_COUNTY, width: 75, dataSource: "inspectionAddress.county" },
			{ code: COL_CODE_CITY, width: 110, dataSource: "inspectionAddress.city" },
			{ code: COL_CODE_STATE, dataSource: "inspectionAddress.stateAbbreviation" },
			{ code: COL_CODE_ZIP, dataSource: "inspectionAddress.zip" },
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ key: "supplementTypes", name: "Supplements", width: 105, dataSource: row => row.supplementTypes.join(", ") }] : []),
			//insured full name formatting should probably be pushed to the server
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ code: COL_CODE_INSURED_NAME, dataSource: row => row?.insuredFirstName ?? "" + " " + row?.insuredLastName ?? "" }] : []),
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ code: COL_CODE_MAC, dataSource: "mac" }] : []),
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ key: "webTime", name: "Web Time", width: 85, dataType: DATA_TYPE_NUMBER, formatter: FORMATTER_CENTER_ALIGN, dataSource: "webTime" }] : []),
			...(this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE ? [{ key: "siteTime", name: "Site Time", width: 85, dataType: DATA_TYPE_NUMBER, formatter: FORMATTER_CENTER_ALIGN, dataSource: "siteTime" }] : []),
			...(this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL ? [{ key: "minimumExperience", name: "Min Exp", width: 85, dataType: DATA_TYPE_NUMBER, formatter: FORMATTER_CENTER_ALIGN, dataSource: "customer.appraiserMinimumYearExperience" }] : []),
		];
	}

	removeRow(controlIdNumber) {
		this.props.onDeselectCases(controlIdNumber);
	}

	filteredAppraisalCases() {
		if (!this.state.selectedCaseDetails) return [];

		const selectedExperience = this.props.inspectorDetails?.experienceYears;
		const excludedCustomerNumbers = this.props.inspectorDetails ?
			this.props.inspectorDetails.customerExclusionLists.customerExclusionLists
				.reduce((acc, val) => acc.concat(val), [])
				.map(o => o.customers.number) : [];
		return this.state.selectedCaseDetails?.filter(c => selectedExperience >= c.customer.appraiserMinimumYearExperience
			&& !excludedCustomerNumbers.includes(c.customer.number));
	}

	filteredInsuranceCases() {
		const excludedCustomerNumbers = this.props.inspectorDetails ?
			this.props.inspectorDetails.customerExclusionLists.customerExclusionLists
				.reduce((acc, val) => acc.concat(val), [])
				.map(o => o.customers.number) : [];
		// Users with FIELD_REP_ASSIGNMENT_OVERRIDE right can assign cases even if the FR is missing designations
		if (this.props.hasFrAssignmentOverride) {
			return this.state.selectedCaseDetails?.filter(c => !excludedCustomerNumbers.includes(c.customer.number));
		}
		const designationCodes = this.props.inspectorDetails ? this.props.inspectorDetails.designationCodes : [];
		return this.state.selectedCaseDetails?.filter(c => !excludedCustomerNumbers.includes(c.customer.number)
			&& designationCodes.includes(c.surveyTypeGroupCode));
	}

	getGridDataSource() {
		if (this.props.displayMode === DISPLAY_MODE_CASE_DETAILS) {
			if (!this.props.selectedInspectors?.length && !this.inspectorDetailsLoaded())
				return this.state.selectedCaseDetails || [];
			if (this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE) 
				return this.filteredInsuranceCases() || [];
			return this.filteredAppraisalCases() || [];
		}
		else {
			return this.state.assignedCaseDetails || [];
		}
	}

	gridRowClicked(i) {
		this.props.onCaseSelected(this.getGridDataSource()[i]);
	}

	getInspectorDropdownItems() {
		if (!this.props.selectedInspectors) {
			return [];
		}
		return this.props.selectedInspectors.map(i => {
			return {
				label: i.displayName,
				value: i.inspectorNumber
			};
		}).sort((a, b) => a.label.localeCompare(b.label));
	}

	fieldRepSelected(inspectorNumber, initialLoad) {
		let selectedInspector = this.props.selectedInspectors.find(i => i.inspectorNumber === inspectorNumber);

		// For some reason the SelectField control will not update to show the proper selected field if state is changed in the onChange handler
		setTimeout(() => {
			this.props.onInspectorSelected(selectedInspector);
			this.setState({
				selectedInspector: selectedInspector,
				...(this.props.displayMode === DISPLAY_MODE_INSPECTOR_CASES && { selectedIndexes: [], lastIndexSelected: null })
			});
			if (!initialLoad && (!this.state.selectedCaseDetails || !this.state.selectedCaseDetails.length) && !this.props.isFetchingCaseDetails) this.props.onDisplayModeChanged(DISPLAY_MODE_INSPECTOR_CASES);
		}, 100);
	}

	inspectorDetailsLoaded() {
		return !this.props.isFetchingInspectorDetails && this.props.inspectorDetails;
	}

	hasSelectedInspectorAndCases() {
		return this.state.selectedInspector && this.state.selectedCaseDetails?.length;
	}

	assignClicked() {
		this.props.onAssign(this.state.selectedCaseDetails.map(c => c.caseLocation.caseId), this.state.selectedInspector.inspectorNumber);
	}

	unassignClicked() {
		this.props.onUnassign(this.state.assignedCaseDetails.filter((row, idx) => this.state.selectedIndexes.includes(idx)).map(row => row.caseLocation.caseId));
		this.setState({ selectedIndexes: [], lastIndexSelected: null });
	}

	onRowsSelected(rows) {
		if (window.getSelection) window.getSelection().removeAllRanges();
		else if (document.selection) document.selection.empty();

		let isIndexSelected = index => this.state.selectedIndexes.indexOf(index) >= 0;

		if (rows.length < 1) return;

		let previ = this.state.lastIndexSelected;

		let rowRange = rowRange = rows.map(r => r.rowIdx);
		let i = rowRange[0];
		let isSelect = true;// Default to true in case multiple rows were passed in

		// Multiple rows sent when select/deselect all is pressed
		if (rows.length === 1) {
			if (this.state.shiftKeyDown && previ !== null) {
				for (let j = Math.min(i, previ) + 1; j <= Math.max(i, previ); j++)rowRange.push(j);
				isSelect = isIndexSelected(this.state.lastIndexSelected);
			} else {
				isSelect = !isIndexSelected(i);
			}
		}

		if (isSelect) {
			this.setState({ selectedIndexes: [...new Set(this.state.selectedIndexes.concat(rowRange))], lastIndexSelected: i });
		} else {
			this.setState({ selectedIndexes: this.state.selectedIndexes.filter(j => !rowRange.includes(j)), lastIndexSelected: i });
		}
	}

	onRowsDeselected(rows) {
		// Multiple rows sent when select/deselect all is pressed
		if (rows.length > 1) {
			let rowRange = rowRange = rows.map(r => r.rowIdx);
			this.setState({ selectedIndexes: this.state.selectedIndexes.filter(j => !rowRange.includes(j)), lastIndexSelected: null });
		} else {
			this.onRowsSelected(rows);//this will handle select and deselect
		}
	}

	onInspectorDetailsClicked() {
		if (this.props.displayMode === DISPLAY_MODE_CASE_DETAILS) {
			this.props.onDisplayModeChanged(DISPLAY_MODE_INSPECTOR_CASES);
		} else {
			this.props.onDisplayModeChanged(DISPLAY_MODE_CASE_DETAILS);
		}
	}

	removeSelectedCases() {
		this.props.onDeselectCases(this.state.selectedCaseDetails.filter((row, idx) => this.state.selectedIndexes.includes(idx)).map(row => row.caseLocation.caseId));
		this.setState({ selectedIndexes: [], lastIndexSelected: null });
	}

	formatMinutesToTimeString(mins) {
		let ret = "";
		mins = Math.floor(mins);

		if (mins >= 60)
			ret += `${Math.floor(mins / 60)} hr`;

		if (mins % 60 !== 0)
			ret += ` ${mins % 60} min`;

		return ret;
	}

	routingClicked() {
		if (!this.state.selectedCaseDetails || this.state.selectedCaseDetails.length === 0) {
			alert("Please select cases before routing");
		} else if (this.state.selectedCaseDetails.length > 23) {
			alert("Routing has a maximum limit of 23 cases");
		} else {
			this.props.onRoutingClicked();
		}
	}

	getDetailsControls() {
		if (this.props.routingData) {
			return (
				<div>
					<div className="details-title" style={{ fontWeight: "bold" }}>Routing Details:</div>
					<ReadOnlyField singleLine title="Drive/On Site Time" fieldValue={this.formatMinutesToTimeString(this.props.routingData.driveAndSiteMinutes)} />
					<ReadOnlyField singleLine title="Total Drive Time" fieldValue={this.formatMinutesToTimeString(this.props.routingData.driveMinutes)} />
					<ReadOnlyField singleLine title="Mileage Cost" fieldValue={"$" + this.props.routingData.mileageCost.toFixed(2)} />
					<ReadOnlyField singleLine title="Total Distance" fieldValue={this.props.routingData.distance.toFixed(2) + " mi"} />
				</div>);
		} else if (this.state.selectedInspector) {
			if (this.inspectorDetailsLoaded()) {
				let inspectorExpectedHours = this.props.assignedCaseDetails?.reduce((acc,c) => acc + (c.webTime + c.siteTime + c.driveTime) / 60, 0);
				let inspectorExpectedHoursAssignedLast7Days = this.props.assignedCaseDetails?.filter(w => (new Date() - new Date(w.dateAssigned)) / (1000 * 3600 * 24) <= 7).reduce((acc,m) => acc + (m.webTime + m.siteTime + m.driveTime) / 60, 0);
				return (
					<div>
						<div className="details-title" style={{ fontWeight: "bold" }}>{this.getAssigneeLabel()} Details:</div>
						<ReadOnlyField singleLine title="Number of Cases" fieldValue={this.props.inspectorDetails.countCases} />
						<ReadOnlyField singleLine title="Expected hours (total)" fieldValue={this.props.assignedCaseDetails?.length ? inspectorExpectedHours.toFixed(2) : "loading..."} />
						<ReadOnlyField singleLine title="Expected hours (7 days)" fieldValue={this.props.assignedCaseDetails?.length ? inspectorExpectedHoursAssignedLast7Days.toFixed(2) : "loading..."} />
						<ReadOnlyField singleLine title="Assigned Today" fieldValue={this.props.inspectorDetails.countCasesAssignedToday} />
						<ReadOnlyField singleLine title="Past Due" fieldValue={this.props.inspectorDetails.countPastDueCases} />
						<ReadOnlyField singleLine title="Rejected" fieldValue={this.props.inspectorDetails.countRejectedCases} />
						<ReadOnlyField singleLine title="Submitted (7 days)" fieldValue={this.props.inspectorDetails.countCasesSubmittedLast7Days} />
						{this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL &&
							<ReadOnlyField singleLine title="Experience" fieldValue={`${this.props.inspectorDetails.experienceYears.toFixed(1)} years`} />}
					</div>);
			} else {
				return <MSpinner />;
			}
		}
	}

	getFilteredCasesMessage() {
		if (this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL) {
			return "Cases filtered based on selected appraiser's experience and customer exclusions";
		}
		if (this.props.hasFrAssignmentOverride) {
			return "Cases filtered based on selected FR's customer exclusions";
		}
		return "Cases filtered based on selected FR's designations and customer exclusions";
	}

	renderGrid() {
		let fetching = (this.props.displayMode === DISPLAY_MODE_INSPECTOR_CASES && this.props.isFetchingAssignedCaseDetails) ||
			(this.props.displayMode === DISPLAY_MODE_CASE_DETAILS && this.props.isFetchingCaseDetails) ||
			// Show spinner when loading details as cases are filtered by exclusion lists (and experience for appraisers)
			this.props.isFetchingInspectorDetails;
		return (
			<MGrid
				configurationId={this.getGridConfigId()}
				columnDefinitions={this.getColumns()}
				data={this.getGridDataSource()}
				isFetchingData={fetching}
				onRowClick={this.gridRowClicked}
				disableFilters
				allowRowSelection
				onRowSelectionChanged={indexes => this.setState({ selectedIndexes: indexes })}
				selectedRows={this.state.selectedIndexes}
			/>
		);
	}

	countySelectionChanged(event, idx) {
		if (event) {
			if (this.selectedCountyIds.includes(event.value.id)) return this.props.makeToast("This county has already been selected.", "warning");
			this.props.getCountyBoundaries([event.value.id]);
			this.selectedCountyIds[idx] = event.value.id;
			this.selectedCountyIds.push("placeholder"); // this placeholder for the next entry automatically triggers a new field for user to add another county
		} else this.selectedCountyIds.splice(idx, 1);
	}

	formatCountyBoundaries() {
		this.selectedCountyIds = this.selectedCountyIds.filter(id => id !== "placeholder");
		if (!this.selectedCountyIds.length) return this.props.makeToast("Please select at least one county from the dropdown before submitting your changes.", "warning");
		let boundary = {};
		let payload = {
			type: this.selectedCountyIds.length === 1 && this.props.countyBoundaries[this.selectedCountyIds[0]].type === "Polygon" ? "Polygon" : "MultiPolygon",
			coordinates: this.selectedCountyIds.length > 1 ? [] : null,
			mode: this.state.boundaryMode,
		};
		// make sure we're not saving the boundaries as a multipolygon if the user only selects one county unless that county type from google maps api is multipolygon (if not, county region won't render correctly)
		this.selectedCountyIds.map(id => {
			if (this.props.countyBoundaries[id]?.coordinates) {
				if (this.selectedCountyIds.length > 1) {
					this.props.countyBoundaries[id].type === "Polygon" ? payload.coordinates.push(this.props.countyBoundaries[id].coordinates) : payload.coordinates.push(this.props.countyBoundaries[id].coordinates.reduce((acc, arr) => acc.concat(arr)));
				} else payload.coordinates = this.props.countyBoundaries[id].coordinates;
			} else this.props.makeToast("There was an error saving your changes. Please end and try again.", "error");
		});
		boundary = { payload, clearMapCallback: () => {}};
		this.props.saveFRServiceBoundary(boundary);
	}

	startCountySelection() {
		const { frGeoCoverageMode, hideExtraDetails, hideCasePins, saveFRServiceBoundary } = this.props;
		frGeoCoverageMode(true);
		hideExtraDetails();
		hideCasePins([]);
		saveFRServiceBoundary(null);
		this.setState({ showCountyDialog: true });
	}

	beginFRGeoCoverage() {
		const { inspectorDetails, makeToast, frGeoCoverageMode, hideExtraDetails, hideCasePins, saveFRServiceBoundary } = this.props;
		if (!inspectorDetails?.inspectorLocation?.inspectorNumber) return makeToast("Please select a field rep.", "warning");
		let selectOrDrawDialogActions = [{
			key: "selectCounty",
			label: "Select County",
			isPrimary: true,
			raised: true,
			onClick: () => {
				this.setState({ boundaryMode: "county" });
				this.startCountySelection();
			} 
		}, {
			key: "drawRegion",
			label: "Draw Region",
			isPrimary: true,
			raised: true,
			onClick: () => {
				this.setState({ boundaryMode: "draw" });
				frGeoCoverageMode(true);
				hideExtraDetails();
				hideCasePins([]);
				saveFRServiceBoundary(null);
			}
		}, {
			key: "cancel",
			isPrimary: false,
			label: "Cancel",
			onClick: () => frGeoCoverageMode(false)
		}];
		if (inspectorDetails?.serviceBoundary) {
			this.context.show(null, `You are about to overwrite the existing region for ${inspectorDetails?.inspectorLocation?.displayName}. How would you like to proceed?`, selectOrDrawDialogActions); 
		} else this.context.show(null, `You are about to begin creating a service region for ${inspectorDetails?.inspectorLocation?.displayName}. How would you like to proceed?`, selectOrDrawDialogActions);
	}

	endFRGeoCoverage() {
		const { tempFRGeoServiceRegion, makeToast, inspectorDetails, frGeoCoverageMode, saveFRServiceBoundary, getInspectorDetails } = this.props;
		if (!tempFRGeoServiceRegion && this.state.boundaryMode === "draw") return makeToast("Please draw a region before saving.", "error");
		if (tempFRGeoServiceRegion && inspectorDetails?.inspectorLocation?.inspectorNumber) {
			updateFRServiceBoundary(inspectorDetails?.inspectorLocation?.inspectorNumber, JSON.stringify(tempFRGeoServiceRegion.payload), () => {
				tempFRGeoServiceRegion.clearMapCallback();
				getInspectorDetails(inspectorDetails?.inspectorLocation?.inspectorNumber);
				makeToast("Service region saved.", "success");
			}, () => {
				tempFRGeoServiceRegion.clearMapCallback();
				makeToast("There was an error saving your service region.", "error");
			}, this.mounted);
			frGeoCoverageMode(false);
			saveFRServiceBoundary(null);
			this.setState({ boundaryMode: "" });
			this.selectedCountyIds = ["placeholder"];
		}
	}

	render() {
		let expectedHoursSeletedCases = 0;
		this.state.selectedCaseDetails?.map(c => expectedHoursSeletedCases += ((c.webTime + c.siteTime + c.driveTime) / 60));
		let countySelectDialogActions = [{
			key: "submit",
			isPrimary: true,
			label: "Submit",
			onClick: () => {
				this.formatCountyBoundaries();
				this.setState({ showCountyDialog: false });
			}
		}, {
			key: "cancel",
			isPrimary: false,
			label: "Cancel",
			onClick: () => {
				this.props.frGeoCoverageMode(false);
				this.setState({ boundaryMode: "", showCountyDialog: false });
				this.selectedCountyIds = ["placeholder"];
			}
		}];
		let countySelectDialogChildren = [
			<div key={"county-selection-dialog"}>Please select the counties you wish to assign to {this.props.inspectorDetails?.inspectorLocation?.displayName}: 
				{this.selectedCountyIds.map((elem, i) => (<MSelect
					className={`mselect-county-selection-${i}`}
					key={`mselect-county-selection-${i}`}
					id={`mselect-county-selection-${i}`}
					options={this.props.countyList}
					isClearable
					onChange={(e) => this.countySelectionChanged(e, i)}
					getMenuPortalTarget={() => document.querySelector(`mselect-county-selection-${i}`)}
				/>))}
			</div>];
			let countySelectDialogProps = { className: "county-selection" };
		return (
			<div className="selection-details-control">
				<div className="selection-details">
					<div className="inspector-controls">
						<IconButton
							color={this.props.displayMode === DISPLAY_MODE_INSPECTOR_CASES ? "primary" : "default"}
							className="inspector-details-button"
							onClick={this.onInspectorDetailsClicked}
							disabled={!this.state.selectedInspector}>
							<Icon>person</Icon>
						</IconButton>
						<TextField
							id="inspector-selector"
							className="inspector-selector"
							select
							variant="standard"
							label={this.props.selectedInspectors.length ? this.getAssigneeLabel(true) : `No ${this.getAssigneeLabel()}s Selected`}
							disabled={!this.props.selectedInspectors.length}
							onChange={(e) => this.fieldRepSelected(e.target.value)}
							value={this.state.selectedInspector && this.state.selectedInspector.inspectorNumber || ""}
							fullWidth
						>
							{this.getInspectorDropdownItems().map(item => (
								<MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
							))}
						</TextField>
					</div>
					{(!this.props.collapsed) && this.props.displayMode === DISPLAY_MODE_CASE_DETAILS && this.props.selectedCaseDetails &&
						<div>
							<ReadOnlyField singleLine className="cases-selected" title="Cases Selected" fieldValue={this.state.selectedCaseDetails.length} />
							<ReadOnlyField singleLine className="cases-expected-hours" title="Expected hours" fieldValue={this.state.selectedCaseDetails.length ? expectedHoursSeletedCases.toFixed(2) : "n/a"} />
							<ReadOnlyField singleLine className="cases-total-mac" title="Total MAC" fieldValue={moneyFormatter(2)(this.state.selectedCaseDetails.reduce((total, cd) => total + cd.mac, 0))} />
						</div>
					}
					{!this.props.collapsed && this.getDetailsControls()}
					{this.props.displayMode === DISPLAY_MODE_CASE_DETAILS && this.props.selectedCaseDetails ? (
						<div className="selection-details-actions">
							<Button
								variant="contained"
								color="primary"
								disabled={this.state.selectedIndexes.length === 0}
								onClick={this.removeSelectedCases}
							>Remove</Button>
							<Button
								variant="contained"
								color={this.state.selectedCaseDetails?.length <= 23 ? "primary" : "inherit"}
								disabled={!this.hasSelectedInspectorAndCases()}
								onClick={this.routingClicked}
							>Routing</Button>
							<Button
								variant="contained"
								onClick={this.props.onDeselectAllPins}
							>Cancel</Button>
							<Button
								variant="contained"
								color="primary"
								disabled={!this.hasSelectedInspectorAndCases()}
								onClick={this.assignClicked}
							>Assign</Button>
						</div>
					) : (
						<div className="selection-details-actions">
							<Button
								variant="contained"
								onClick={this.props.onDeselectAllPins}
							>Cancel</Button>
							<Button
								variant="contained"
								color="primary"
								disabled={this.state.selectedIndexes.length === 0}
								onClick={this.unassignClicked}
							>{this.props.isUnassigning ? "Unassigning" : "Unassign"}</Button>
						</div>
					)}
				</div>
				<div className="selection-details-type">
					<div>{this.props.isFRGeoCoverageMode ? "Field Rep Service Region" : this.props.displayMode === DISPLAY_MODE_CASE_DETAILS ? "Selected Cases" : "Assigned Cases"}</div>
				</div>
				<div className="selection-details-grid">
					{this.props.isFRGeoCoverageMode && this.props.inspectorDetails?.inspectorLocation?.displayName 
						? <div className="selection-details-filter-message">Editing field rep {this.props.inspectorDetails?.inspectorLocation?.displayName} service region</div> 
						: (this.props.displayMode === DISPLAY_MODE_CASE_DETAILS && this.state.selectedInspector) &&
							<div className="selection-details-filter-message">{this.getFilteredCasesMessage()}</div>}
					{this.renderGrid()}
				</div>
				{this.state.showCountyDialog && this.context.show("County Selection", countySelectDialogChildren, countySelectDialogActions, countySelectDialogProps)}
			</div>
		);
	}
}

SelectionDetails.propTypes = {
	assignmentMode: PropTypes.string.isRequired,
	selectedCaseDetails: PropTypes.array,
	isFetchingCaseDetails: PropTypes.bool,
	assignedCaseDetails: PropTypes.array,
	isFetchingAssignedCaseDetails: PropTypes.bool,
	selectedInspectors: PropTypes.array,
	onDeselectCases: PropTypes.func.isRequired,
	onDeselectAllPins: PropTypes.func.isRequired,
	onRoutingClicked: PropTypes.func.isRequired,
	onDisplayModeChanged: PropTypes.func.isRequired,
	isRouting: PropTypes.bool.isRequired,
	onInspectorSelected: PropTypes.func.isRequired,
	onAssign: PropTypes.func.isRequired,
	onUnassign: PropTypes.func.isRequired,
	isUnassigning: PropTypes.bool,
	collapsed: PropTypes.bool,
	onCaseSelected: PropTypes.func.isRequired,
	isFetchingInspectorDetails: PropTypes.bool,
	inspectorDetails: PropTypes.object,
	routingData: PropTypes.object,
	displayMode: PropTypes.string,
	hideExtraDetails: PropTypes.func,
	hideCasePins: PropTypes.func,
	showExtraDetails: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	frGeoCoverageMode: PropTypes.func,
	isFRGeoCoverageMode: PropTypes.bool,
	tempFRGeoServiceRegion: PropTypes.object,
	saveFRServiceBoundary: PropTypes.func,
	makeToast: PropTypes.func,
	canEditFRServiceRegion: PropTypes.bool,
	getInspectorDetails: PropTypes.func,
	boundaryMode: PropTypes.string,
	countyList: PropTypes.array,
	countyBoundaries: PropTypes.object,
	getCountyBoundaries: PropTypes.func,
	hasFrAssignmentOverride: PropTypes.bool,
};

export default SelectionDetails;
